export const LOGO_URL = "/prism-logo.webp";

export const NAV_LINKS = [
  { name: "Home", path: "/" },
  { name: "Products", path: "/products" },
  { name: "Services", path: "/services" },
  { name: "About", path: "/about" },
  { name: "Contact", path: "/contact" },
];

export const COMPANY = {
  name: "PRISM Inc.",
  tagline: "Payment Resolution & IDR System Management",
  email: "info@prism.inc",
  address: "United States",
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
